var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fe:document"
  }, /*#__PURE__*/React.createElement("g", {
    id: "feDocument0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "feDocument1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "feDocument2",
    d: "M40 10.6667H16V53.3334H48V18.6667H40V10.6667ZM16 5.33337H42.6667L53.3333 16V53.3334C53.3333 54.7479 52.7714 56.1044 51.7712 57.1046C50.771 58.1048 49.4145 58.6667 48 58.6667H16C14.5855 58.6667 13.2289 58.1048 12.2288 57.1046C11.2286 56.1044 10.6667 54.7479 10.6667 53.3334V10.6667C10.6667 9.25222 11.2286 7.89566 12.2288 6.89547C13.2289 5.89528 14.5855 5.33337 16 5.33337ZM21.3333 29.3334H42.6667V34.6667H21.3333V29.3334ZM21.3333 40H42.6667V45.3334H21.3333V40Z",
    fill: "#004D72"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon-2.d64815c7c233cab470565e408a374cdf.svg";
export { ForwardRef as ReactComponent };